import { axiosInstance } from '@/plugins/axios';
import moment from 'moment';
import { showErrorToast, showSuccessToast } from '@/utils/toast';

// initial state
export const moduleState = {
  searchResults: [],
  transactionTypes: [],
  promos: [],
  isSearching: false,
  pagination: {
    currentPage: 1,
    pageSize: 10,
    totalRecords: 0,
  },
  sortBy: '-createDate',
  to: new Date(),
  from: moment().startOf('month').toDate(),
};

// getters
export const getters = {};

// mutations
export const mutations = {
  setPromos(state, value) {
    state.promos = value;
  },
  setServices(state, value) {
    state.services = value;
  },
  setTransactionTypes(state, value) {
    state.transactionTypes = value;
  },
  setSearchResults(state, value) {
    state.searchResults = value;
  },
  setIsSearching(state, value) {
    state.isSearching = value;
  },
  setPagination(state, value) {
    state.pagination = value;
  },

  setCurrentPage(state, newValue) {
    state.pagination.currentPage = newValue;
  },
  setPageSize(state, newValue) {
    state.pagination.pageSize = newValue;
  },
  setSortBy(state, value) {
    state.sortBy = value;
  },
  setTo(state, newValue) {
    state.to = newValue;
  },
  setFrom(state, newValue) {
    state.from = newValue;
  },
};

// actions
export const actions = {
  async getTransactions({ commit, state, dispatch }, search) {
    const response = await dispatch('request/get', {
      url: `/api/billing/${search.clientId}/transactions`,
      params: {
        q: search.search,
        from: search.from,
        to: search.to,
        page: state.pagination.currentPage,
        pageSize: state.pagination.pageSize,
        sortBy: state.sortBy,
      },
      errorMessage: 'Failed to load transactions',
      loadingMutation: 'transactions/setIsSearching',
    });
    if (!response) {
      commit('setSearchResults', []);
      return;
    }
    commit('setSearchResults', response.data.items);
    commit('setPagination', response.data.metaData);
  },
  async createTransactions(
    { commit },
    { amount, clientId, description, service, createDate, type, promoCode, cardCheckNumber }
  ) {
    try {
      const results = await axiosInstance.post(`/api/billing/${clientId}/transactions`, {
        Amount: amount,
        ClientId: clientId,
        CreateDate: createDate,
        Description: description,
        Service: service,
        TypeCode: type,
        CardCheckNumber: cardCheckNumber,
        PromoCode: promoCode,
      });
      const data = results.data;

      showSuccessToast('Transaction successfully created');

      return data;
    } catch (error) {
      console.error(error);
      commit('setIsSearching', false);
      showErrorToast('Failed to create transaction: ' + error.response.data);
    }
  },
  async getGroupDebtReplacementTransactions({ dispatch }, { clientId, transactionId, amount }) {
    try {
      const response = await dispatch('request/get', {
        url: `/api/billing/${clientId}/transactions/getGroupDebtReplacementTransactions/${transactionId}`,
        params: {
          amount,
        },
      });
      return response.data;
    } catch (error) {
      console.error(error);
      showErrorToast('Error: Getting transactions..');
      return [];
    }
  },
  async replaceTransaction({ dispatch }, { clientId, transactionId, amount }) {
    try {
      await dispatch('request/post', {
        url: `/api/billing/${clientId}/transactions/replaceTransaction/${transactionId}`,
        params: {
          amount,
        },
      });
      showSuccessToast('Transaction removed.');
    } catch (error) {
      console.error(error);
      showErrorToast('Error: Unable to remove transaction.');
    }
  },

  async createServiceTransfer(
    { commit },
    { amount, clientId, description, source, createDate, target }
  ) {
    try {
      const results = await axiosInstance.post(`/api/billing/${clientId}/transfers`, {
        Amount: amount,
        ClientId: clientId,
        CreateDate: createDate,
        Description: description,
        Source: source,
        Target: target,
      });
      const data = results.data;
      return data;
    } catch (error) {
      console.error(error);
      commit('setIsSearching', false);
    }
  },
  async getTransactionTypes({ commit }) {
    try {
      const results = await axiosInstance.get(`/api/billing/transactions/types`);
      commit('setTransactionTypes', results.data);
      return results.data;
    } catch (error) {
      console.error(error);
    }
  },
  async getPromos({ commit }) {
    try {
      const results = await axiosInstance.get(`/api/clients/promos`);
      commit('setPromos', results.data);
      return results.data;
    } catch (error) {
      console.error(error);
    }
  },

  reset({ commit }) {
    commit('setSearchResults', []);
    commit('setPagination', {
      pagination: {
        currentPage: 1,
        pageSize: 10,
        totalRecords: 0,
      },
    });
    commit('setPromos', []);
  },
};
